<template>
  <NavigationBarTop />
  <div class="container">
      <h2 class="page-head">What Our Clients Say</h2>
      <p class="tagline">Hear from our happy customers about their experiences and results.</p>

      <div class="testimonials-list">
        
        <div class="testimonial-card" v-for="(testimonial, index) in testimonials" :key="index">
          
          <div class="rating">
            <span v-for="n in testimonial.rating" :key="n">★</span>
          </div>

          <h3 class="headline-quote">"{{ testimonial.headline }}"</h3>
          
          <p class="testimonial-body">{{ testimonial.body }}</p>

          <div class="client-info">
            <img :src="testimonial.image" :alt="testimonial.name" class="client-avatar">
            
            <div class="client-details">
              <p class="client-name">{{ testimonial.name }}</p>
              <p class="client-title">{{ testimonial.detail }}</p>
            </div>
          </div>
        </div>
        
      </div>
      
      <section class="submission-section">
          <h3>Share Your Experience</h3>
          <form @submit.prevent="submitTestimonial" class="testimonial-form">
              <div class="form-group">
                  <label for="clientName">Your Name:</label>
                  <input type="text" id="clientName" v-model="newTestimonial.name" required>
              </div>
              <div class="form-group">
                  <label for="clientHeadline">Headline:</label>
                  <input type="text" id="clientHeadline" v-model="newTestimonial.headline" required>
              </div>
              <div class="form-group">
                  <label for="clientBody">Your Story:</label>
                  <textarea id="clientBody" v-model="newTestimonial.body" rows="5" required></textarea>
              </div>
              <button type="submit" class="submit-button">Submit Testimonial</button>
          </form>
      </section>

    </div>
</template>

<script>
import NavigationBarTop from '@/components/NavigationBarTop.vue'
export default {
    components: {
        NavigationBarTop
    },
    data() {
        return {
            testimonials: [
                {
                    rating: 5,
                    headline: "Best color and cut I've had in years!",
                    body: "The team was professional, and my stylist truly listened to what I wanted. I left feeling completely refreshed and confident. Highly recommend Chic Curls Salon!",
                    name: "Sarah M.",
                    detail: "Regular Client Since 2023",
                    image: 'https://via.placeholder.com/60/FF7F50/FFFFFF?text=SM' // Placeholder image
                },
                {
                    rating: 4,
                    headline: "Incredible service and relaxing atmosphere.",
                    body: "I was nervous about a new style, but the consultation was thorough. The results speak for themselves—perfect blow-out and conditioning treatment. I'll be back!",
                    name: "David T.",
                    detail: "First-Time Customer",
                    image: 'https://via.placeholder.com/60/008080/FFFFFF?text=DT' // Placeholder image
                },
                
                {
                    rating: 5,
                    headline: "Best color and cut I've had in years!",
                    body: "The team was professional, and my stylist truly listened to what I wanted. I left feeling completely refreshed and confident. Highly recommend Chic Curls Salon!",
                    name: "Sarah M.",
                    detail: "Regular Client Since 2023",
                    image: 'https://via.placeholder.com/60/FF7F50/FFFFFF?text=SM'
                },
                {
                    rating: 4,
                    headline: "Incredible service and relaxing atmosphere.",
                    body: "I was nervous about a new style, but the consultation was thorough. The results speak for themselves—perfect blow-out and conditioning treatment. I'll be back!",
                    name: "David T.",
                    detail: "First-Time Customer",
                    image: 'https://via.placeholder.com/60/008080/FFFFFF?text=DT'
                },
                {
                    rating: 5,
                    headline: "Truly talented stylists!",
                    body: "I came in with damaged hair and walked out feeling like a new person. The deep conditioning treatment was a miracle worker. Five stars all around for the staff's attention to detail.",
                    name: "Emily R.",
                    detail: "Walk-in Client",
                    image: 'https://via.placeholder.com/60/DAA520/FFFFFF?text=ER'
                }
            ],
            // Data for the input form
            newTestimonial: {
                name: '',
                headline: '',
                body: ''
            }
        }
    },
    methods: {
        submitTestimonial() {
            console.log("New Testimonial Submitted:", this.newTestimonial);
            
            alert("Thank you for your feedback! It will be reviewed before being posted.");
            
            this.newTestimonial = { name: '', headline: '', body: '' };
        }
    }
    
}
</script>

<style scoped>

.container {
    max-width: 900px; /* Constraining the max width slightly for better readability */
    margin: 0 auto;
    padding: 0 1rem;
}

.page-head {
    font-size: 2.5rem;
    color: #1c1917;
    margin-top: 2rem;
    text-align: center;
}

.tagline {
    text-align: center;
    color: #666;
    margin-bottom: 3rem;
    font-size: 1.1rem;
}

/*  Testimonials List*/
.testimonials-list {
    /* No grid, allowing default block flow for vertical scrolling */
    padding-bottom: 3rem;
}

.testimonial-card {
    background: #ffffff;
    border: 1px solid #ddd;
    border-radius: 12px;
    padding: 25px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    margin-bottom: 25px; /* Spacing between full-width cards */
    width: 100%; /* Spans the width of its container */
}
.rating {
    color: gold;
    font-size: 1.5rem;
    margin-bottom: 10px;
}

.headline-quote {
    font-size: 1.4rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
    font-style: italic;
}

.testimonial-body {
    font-size: 1rem;
    color: #555;
    line-height: 1.6;
    margin-bottom: 20px;
}

.client-info {
    display: flex;
    align-items: center;
    padding-top: 15px;
    border-top: 1px dashed #eee;
}

.client-avatar {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 15px;
    border: 2px solid crimson;
}

.client-name {
    font-weight: bold;
    color: crimson;
    margin: 0;
}

.client-title {
    font-size: 0.9rem;
    color: #888;
    margin: 0;
}

/* Submission Form Styles*/
.submission-section {
    background: #f8f8f8;
    padding: 30px;
    border-radius: 12px;
    border: 1px solid #eee;
    margin-bottom: 3rem;
}

.submission-section h3 {
    color: #333;
    font-size: 1.8rem;
    border-bottom: 2px solid crimson;
    padding-bottom: 10px;
    margin-bottom: 25px;
}

.testimonial-form {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.form-group {
    display: flex;
    flex-direction: column;
}

.form-group label {
    font-weight: 600;
    color: #555;
    margin-bottom: 5px;
}

.form-group input[type="text"],
.form-group textarea {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
    width: 100%;
    box-sizing: border-box;
}

.form-group textarea {
    resize: vertical;
}

.submit-button {
    background-color: crimson;
    color: white;
    padding: 12px 20px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 1.1rem;
    font-weight: bold;
    transition: background-color 0.3s;
}

.submit-button:hover {
    background-color: #c0003c; /* Darker crimson */
}
</style>